module.exports = __webpack_public_path__ + "img/side-icon-31-off.d32ca629.svg";